import { useMemo, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import type { Combatant } from './simulation'
import { lifePresentation, lifeVisualSignature, type LivingState } from './lifeOmega'

export function LivingStateVfx({combatant,life,accent}:{combatant:Combatant;life:LivingState;accent:string}){
  const root=useRef<THREE.Group>(null),core=useRef<THREE.Mesh>(null)
  const ring=useRef<THREE.Mesh>(null),nerve=useRef<THREE.Mesh>(null)
  const color=useMemo(()=>new THREE.Color(accent),[accent])
  const presentation=lifePresentation(life),signature=lifeVisualSignature(life.family)
  useFrame(({clock},dt)=>{
    if(!root.current)return
    const t=clock.elapsedTime,pulse=Math.pow((Math.sin(t*(4.3+presentation.pulse*2.1)*signature.pulseRate)+1)*.5,7)
    const breath=Math.sin(t*(1.35+presentation.breathing*1.5))*presentation.breathing*signature.breathGain
    const tremor=Math.sin(t*33.7+life.eventSerial*.37)*presentation.tremor*.025
    const reflexKick=presentation.reflex*.035
    root.current.position.set(combatant.x+tremor,combatant.y+.96+breath*.035+reflexKick,combatant.z)
    root.current.rotation.y+=dt*(.18+presentation.electrical*.9)*signature.ringSpin
    if(core.current){const s=.11+presentation.pulse*.045+pulse*.08;core.current.scale.setScalar(s)
      ;(core.current.material as THREE.MeshBasicMaterial).opacity=.11+presentation.distress*.2+pulse*.2}
    if(ring.current){const s=.78+presentation.breathing*.18+pulse*.12;ring.current.scale.setScalar(s)
      ;(ring.current.material as THREE.MeshBasicMaterial).opacity=.035+presentation.distress*.12+pulse*.08}
    if(nerve.current){nerve.current.rotation.z+=dt*(.25+presentation.electrical*3)*signature.nerveGain
      ;(nerve.current.material as THREE.MeshBasicMaterial).opacity=presentation.electrical*signature.nerveGain*(.08+.18*pulse)}
  })
  return <group ref={root} name="life-omega-state">
    <mesh ref={core}><sphereGeometry args={[1,12,10]}/>
      <meshBasicMaterial color={color} transparent depthWrite={false} blending={THREE.AdditiveBlending}/></mesh>
    <mesh ref={ring} rotation={[-Math.PI/2,0,0]} position={[0,-.92,0]}>
      <torusGeometry args={[1,.022,6,30]}/>
      <meshBasicMaterial color={color} transparent depthWrite={false} blending={THREE.AdditiveBlending}/></mesh>
    <mesh ref={nerve} rotation={[Math.PI/2,0,0]}><torusGeometry args={[.42,.009,5,22]}/>
      <meshBasicMaterial color={color} transparent depthWrite={false} blending={THREE.AdditiveBlending}/></mesh>
  </group>
}
